import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcDrawer',
  props: {},
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  render() {
    const { $attrs, $listeners, $slots, $scopedSlots } = this;
    const getPrefixCls = this.configProvider.getPrefixCls;
    const prefixCls = getPrefixCls('', 'fc-drawer');
    return (
      <div>
        <a-drawer
          class={`${prefixCls}`}
          {...{ props: $attrs }}
          {...{ on: $listeners }}
          {...{ scopedSlots: $scopedSlots }}
        >
          <div class="content">{$slots.content}</div>
        </a-drawer>
      </div>
    );
  },
};
